import { call, put } from "redux-saga/effects";
import { ApprovalAction } from "./action";
import axios from "axios";
import { API_URL } from "../../utils/Constant"; // centralized API base URL

//  API call using API_URL
function fetchApprovalsAPI() {
  return axios.get(`${API_URL}/approval-affiliations-list`);
}

// Saga function 
export function* fetchApprovalsSaga() {
  try {
    const response = yield call(fetchApprovalsAPI);
    if (response.data.success) {
      yield put({
        type: ApprovalAction.GET_APPROVALS_SUCCESS,
        payload: response.data.data,
      });
    } else {
      yield put({
        type: ApprovalAction.GET_APPROVALS_FAILURE,
        payload: "API returned failure",
      });
    }
  } catch (error) {
    yield put({
      type: ApprovalAction.GET_APPROVALS_FAILURE,
      payload: error.message,
    });
  }
}
